import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import DropDownInputField from "../../../components/forms/DropDownInputField";
import TextInputField from "../../../components/forms/TextInputField";
import FormError from "../../../components/forms/FormError";

class AddWaterContainerToPalletForm extends Component {

  render() {
    let {errors, handleSubmit, resultOptions, submit, products, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Serial Nr."
              name="inventoryId"
              component={TextInputField}
              serverError={this.props.errors.inventoryId}
              />
            <Field 
              label="Product"
              name="inventorySku"
              component={DropDownInputField}
              data={products}
              valueKey="sku"  
              titleKey="sku" 
              showBlank={true}
              serverError={this.props.errors.inventorySku}
              />
            <Field 
              label="Test Result"
              name="testResult"
              component={DropDownInputField}
              data={resultOptions}
              valueKey="id"  
              titleKey="title" 
              serverError={this.props.errors.result}
              />
            <Field 
              label="Test Lab"
              name="labName"
              component={TextInputField}
              serverError={this.props.errors.labName}
              />
            <Field 
              label="Test nr"
              name="testNr"
              component={TextInputField}
              serverError={this.props.errors.testNr}
              />              
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "AddWaterContainerToPalletForm"
})(AddWaterContainerToPalletForm);

export default ReduxForm;